//============================================================================================================
//  GLOBAL VARS
//============================================================================================================

var fancyOverlayColor = '#fff';
var fancyOverlayOpacity = 0.75;
var rating = 4.3;

//============================================================================================================
//  DOCUMENT READY
//============================================================================================================
$(document).ready(function () {

    initMyAccountFunctions();
    initCheckoutFunction();

    function initMyAccountFunctions() {
        if (typeof (InitMyAccountFunctions) == "function")
            InitMyAccountFunctions();
    };

    function initCheckoutFunction() {
        if (typeof (InitCheckoutFunctions) == "function")
            InitCheckoutFunctions();
    };

    $('*[data-numbers-allowed="true"]').keyup(function () {
        var value = this.value.replace(/[^0-9\.,]/g, '');

        if (this.value != value) {
            this.value = value;
        }
    });

    initTooltips();
    initTooltips2();
    $enableFormatPrices = true;
    formatPrices();
});



//============================================================================================================
//  DOCUMENT READY END
//============================================================================================================
function numbersOnly(event) {
    // left arrow, right arrow, tab
    if (event.keyCode == 37 || event.keyCode == 39 || event.keyCode == 9) {
    }
    else if (event.keyCode == 46 || event.keyCode == 8 || event.keyCode == 36 || event.keyCode == 35) { // delete, backspace, home, end
    }
    else {
        if (event.keyCode < 95) {
            if (event.keyCode < 48 || event.keyCode > 57) // numbers
                event.preventDefault();
        }
        else {
            if (event.keyCode < 96 || event.keyCode > 105) // keypad
                event.preventDefault();
        }
    }
}

function preventSpecialCharacter(e) {
    var shiftPressed = e.shiftKey;
    var keyCode = e.keyCode;

    if (shiftPressed) {
        // In Order: '<', '>', '#', '&', '%', '{', '}'
        if (keyCode == 188 || keyCode == 190 || keyCode == 51 || keyCode == 55 || keyCode == 53 || keyCode == 219 || keyCode == 221)
            e.preventDefault();
    } else {
        // In Order: '/', '[', ']', '/(numPad)', '&', '%'
        if (keyCode == 191 || keyCode == 219 || keyCode == 221 || keyCode == 111)
            e.preventDefault();
    }
};

function phoneGROnly(event) {
    numbersOnly(event);
    if ($(event.currentTarget).val().length > 9)
        // delete, backspace, home, end, left arrow, right arrow, tab
        if (event.keyCode == 46 || event.keyCode == 8 || event.keyCode == 36 || event.keyCode == 35 || event.keyCode == 37 || event.keyCode == 39 || event.keyCode == 9) { }
        else { event.preventDefault(); }
}

function stickyContainer(container, cssClass) {
    //Sticky container on scroll

    //Call Example
    //stickyContainer($('.header-region'), 'sticky');

    var containerHeight = container.height();
    var scrlTop = $(window).scrollTop();
    container.before("<div class='spacer'></div>");
    var spacer = $('.spacer');

    //Initialize
    if (scrlTop >= containerHeight) {
        spacer.height(containerHeight);
        container.addClass(cssClass);
    }
    else {
        spacer.height(0);
        container.removeClass(cssClass);
    }

    /* respond to scroll event */
    $(window).scroll(function () {
        scrlTop = $(window).scrollTop();
        if (scrlTop >= containerHeight) {
            spacer.height(containerHeight);
            container.addClass(cssClass);
        }
        else {
            spacer.height(0);
            container.removeClass(cssClass);
        }
    });
}

function scroll_to_class(element_class, removed_height) {
    var scroll_to = $(element_class).offset().top - removed_height;
    if ($(window).scrollTop() != scroll_to) {
        $('html, body').stop().animate({
            scrollTop: scroll_to
        }, 0);
    }
}

function saveProductToStorage(id, skuId, path, qty, defaultcolorId, extraAttributes, bundleItems, recipeItems, comboItems, itemInfo) {
    product = {
        id: id,
        skuId: skuId,
        path: path,
        qty: qty,
        defaultcolorId: defaultcolorId,
        extraAttributes: extraAttributes,
        bundleItems: bundleItems,
        recipeItems: recipeItems,
        comboItems: comboItems,
        itemInfo: itemInfo
    };
    Lockr.set('product', product);
}

function notPartOfComboProductsToStorage(id, skuId, path, qty, defaultcolorId, extraAttributes, bundleItems, recipeItems, comboItems, itemInfo) {
    var notPartsOfCombo = Lockr.get('notPartsOfCombo');
    if (notPartsOfCombo === undefined || notPartsOfCombo === null) {
        notPartsOfCombo = [];
    }
    notPartsOfCombo.push({
        id: id,
        skuId: skuId,
        path: path,
        qty: qty,
        defaultcolorId: defaultcolorId,
        extraAttributes: extraAttributes,
        bundleItems: bundleItems,
        recipeItems: recipeItems,
        comboItems: comboItems,
        itemInfo: itemInfo
    });
    Lockr.set('notPartsOfCombo', notPartsOfCombo);
}

function hideOnScrollDown(container, cssClass) {
    // Hide container on on scroll down

    //Call Example
    //hideOnScrollDown($('.header-region'), 'hidden');

    var containerHeight = container.height();

    var didScroll;
    var lastScrollTop = 0;
    var delta = 5;

    $(window).scroll(function (event) {
        didScroll = true;
    });

    setInterval(function () {
        if (didScroll) {
            var st = $(this).scrollTop();
            // Make sure they scroll more than delta
            if (Math.abs(lastScrollTop - st) <= delta)
                return;

            // If they scrolled down and are past the navbar, add class .nav-up.
            // This is necessary so you never see what is "behind" the navbar.
            if (st > lastScrollTop && st > containerHeight) {
                // Scroll Down
                container.addClass(cssClass);
            } else {
                // Scroll Up
                if (st + $(window).height() < $(document).height()) {
                    container.removeClass(cssClass);
                }
            }

            lastScrollTop = st;
            didScroll = false;
        }
    }, 250);

}

function validateEmail(email) {
    var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return re.test(email);
}

function isTouch() {
    return ($('.touch').length > 0);
}

function importEmailForRegistration() {

    var email = sessionStorage.getItem('registrationEmail');

    if ($('.x-registration-form').length > 0 && email) {
        $('.x-registration-form input[name="email"]').val(email);
    }

    if ($('.x-registration-b2b-form').length > 0 && email) {
        $('.x-registration-b2b-form input[name="email"]').val(email);
    }

}

function initTooltips() {
    var $wrapper = $('.form-row .tooltip-info-wrapper');

    if ($wrapper.length < 1)
        return;

    $('.info-btn', $wrapper).click(function () {
        var tooltipBox = $(this).siblings('.info-tooltip');
        $('.info-tooltip', $wrapper).not(tooltipBox).hide();
        tooltipBox.toggle();
    });

    $(document).on('click', function (e) {
        if (!$wrapper.is(e.target) && $wrapper.has(e.target).length === 0) {
            $('.info-tooltip', $wrapper).hide();
        }
    });
}
function initTooltips2() {
    var $wrapper = $('.carton-info .tooltip-info-wrapper');

    if ($wrapper.length < 1)
        return;

    $('.info-btn', $wrapper).click(function () {
        var tooltipBox = $(this).siblings('.info-tooltip');
        $('.info-tooltip', $wrapper).not(tooltipBox).hide();
        tooltipBox.toggle();
    });

    $(document).on('click', function (e) {
        if (!$wrapper.is(e.target) && $wrapper.has(e.target).length === 0) {
            $('.info-tooltip', $wrapper).hide();
        }
    });
}

// in case of pages that need to load inside an iframe
// and call parent vendd js to execute some actions
// make sure that parent vendd iframe is accessible
function getParentOrSelfVendd() {
    try {

        if (typeof parent.Vendd != "undefined")
            return parent.Vendd;
    }
    catch (error) { }

    return Vendd;
}

function isElementInViewport(el) {
    //special bonus for those using jQuery

    if (el.length < 1)
        return;

    if (typeof jQuery === "function" && el instanceof jQuery) {
        el = el[0];
    }

    var rect = el.getBoundingClientRect();

    return (
        rect.top >= 0 &&
        rect.left >= 0 &&
        rect.bottom <= (window.innerHeight || document.documentElement.clientHeight) && /*or $(window).height() */
        rect.right <= (window.innerWidth || document.documentElement.clientWidth) /*or $(window).width() */
    );
}


var $enableFormatPrices = false;
function formatPrices($container) {
	if (!$enableFormatPrices) return;
	if (!$container || $container.length < 0) $container = $('html');
	var $boxes = $('[data-format="price"]:not(.price-formatted)', $container);
	$boxes.each(function (index, box) {
		var $box = $(box), amount = $box.html(), formed = "";
		if ($box.hasClass('price-formatted')) return;
		$box.addClass('price-formatted');
		formed = formatPrice(amount);
		$box.html(formed);
	});
	return $boxes.length;
}

function formatPrice(amount) {
	try {
		var sep = LhApp.Context.Currency.DecimalSeparator, cur = decodeEntities(LhApp.Context.Currency.Symbol), pos, formed = "";
		if (!amount) return formed;
		amount = amount.trim();
		pos = amount.indexOf(cur);
		amount = amount.replace(cur, '').trim().split(sep);

		/* Respect number of decimal digits */
		amount[1] = amount[1].substring(0, LhApp.Context.Currency.NumberOfDigits);

		formed += pos == 0 ? '<span class="currency-symbol">' + cur + '</span>' : '';
		formed += amount.length > 0 ? '<span class="integer-part">' + amount[0] + '</span>' : '';
		/* Hides decimal part */
		if (amount[1] == '00') {
			formed += amount.length > 1 ? '<span class="sep no-decimal">' + sep + '</span><span class="decimal-part no-decimal">' + amount[1] + '</span>' : '';
		} else {
			formed += amount.length > 1 ? '<span class="sep">' + sep + '</span><span class="decimal-part">' + amount[1] + '</span>' : '';
		}
		formed += '<span class="currency-symbol">' + cur + '</span>';
		return formed;
	} catch (ex) {
		return amount + LhApp.Context.Currency.Symbol;
	}
}
